import { render, staticRenderFns } from "./MaterialCart.vue?vue&type=template&id=044343d4&scoped=true"
import script from "./MaterialCart.vue?vue&type=script&lang=js"
export * from "./MaterialCart.vue?vue&type=script&lang=js"
import style0 from "./MaterialCart.vue?vue&type=style&index=0&id=044343d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044343d4",
  null
  
)

export default component.exports